import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { BankDetailsRequest } from "./bank-details-request";

export class BankDetailsResponseModel extends GlobalResponseObject{
    data?:BankDetailsRequest[]
     
    constructor(status:boolean, intelCode:number, internalMessage:string ,data?:BankDetailsRequest[]){
    super(status,intelCode,internalMessage)
    this.status=status
    this.intlCode=intelCode
    this.internalMessage=internalMessage
    this.data=data
    }

}